import { GckAssignmentChange } from '../../interfaces/admin/GckAssignmentChange';

export class LoadAllUserGckAssignments {
    static readonly type = '[GCK Assignment] Load All User GCK Assignments';
}

export class LoadGckOptionsForDate {
    static readonly type = '[GCK Assignment] Load GCK Options';
    constructor(public date: Date) {}
}

export class SaveUserGckAssignments {
    static readonly type = '[GCK Assignment] Save User GCK Assignments';
    constructor(public changes: GckAssignmentChange[]) {}
}
